import { CloseIcon } from "@/assets/icons";
import { Button } from "@/components/ui/button";
import MailTo from "@/components/ui/MailTo";
import { CONTACT } from "@/constants/contact";

import { Mail, Phone } from "lucide-react";

interface UnlockPremiumModalProps {
  title: string;
  description: string;
  contactUsDesc: string;
  emailSubject?: string;
  emailBody?: string;
  onClose: () => void;
}

export const UnlockPremiumModal = ({
  title,
  description,
  contactUsDesc,
  emailSubject = "",
  emailBody = "",
  onClose
}: UnlockPremiumModalProps) => {
  return (
    <>
      <button
        aria-label="Close modal"
        className="fixed inset-0 bg-black/50 cursor-auto"
        onClick={onClose}
      />
      <div
        data-testid="unlock-premium-dialog"
        className="absolute top-1/2 left-1/2 w-[456px] bg-white rounded-xl shadow-lg transform -translate-x-1/2 -translate-y-1/2 p-4 flex flex-col gap-4"
      >
        <div className="space-y-1 text-left">
          <div className="flex items-center justify-between">
            <div className="text-txtHeading text-[20px] font-semibold text-left">
              {title}
            </div>
            <CloseIcon
              title="close"
              className="w-6 h-6 cursor-pointer"
              onClick={onClose}
            />
          </div>
          <div className="text-txtBody text-[12px]">{description}</div>
        </div>
        <div>
          <p className="text-sm text-txtHeading font-semibold mb-2">
            Contact Us
          </p>
          <p className="text-txtBody text-[12px]">{contactUsDesc}</p>
        </div>
        <div className="rounded-lg border p-2 grid grid-cols-2">
          <div className="flex items-center gap-2 mb-2">
            <Phone className="w-5 h-5" />
            <div className="flex flex-col gap-1">
              <span className="text-sm text-txtBody">Phone Number</span>
              <span className="text-[12px] font-semibold text-txtBody">
                {CONTACT.PHONE_NUMBER}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-2 mb-2">
            <Mail className="w-5 h-5" />
            <div className="flex flex-col gap-1">
              <span className="text-sm text-txtBody">Email</span>
              <MailTo
                email={CONTACT.EMAIL}
                subject={emailSubject}
                body={emailBody}
              />
            </div>
          </div>
        </div>
        <div>
          <Button
            className="w-full h-[40px] rounded-xl font-semibold text-sm"
            onClick={onClose}
          >
            Got It
          </Button>
        </div>
      </div>
    </>
  );
};
